﻿(function securityLevelConfigDefinition() {
    'use strict';
    angular.module('Entities')
        .service('securityLevelConfigService', [
            'restUrlBuilder', '$injector',
            function securityLevelConfigDefinition(restUrlBuilder, $injector) {

                restUrlBuilder = restUrlBuilder('auth');

                this.get = function () {
                    return restUrlBuilder.all('SecurityLevelConfig')
                        .get();
                };
            }
        ]);
})();